import "core-js/modules/es.array.reduce.js";
import CompilationsApi from '@/frontend/api/compilations';
import WorksApi from '@/frontend/api/works';
import UserWorksApi from '@/frontend/api/userWorks';
import WorksFilterComponent from "@/frontend/components/WorksFilterComponent";
import EmptyResultComponent from '@/frontend/components/EmptyResultComponent';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
import { ElLoading } from 'element-plus';
import setMetas from '@/frontend/functions/setMetas';
export default {
  name: "CompilationPage",
  components: {
    WorksFilterComponent,
    WorkCardComponent,
    EmptyResultComponent
  },

  data() {
    return {
      Compilation: {},
      works: [],
      userWorks: [],
      PaginationLinks: {},
      PaginationMeta: {
        currentPage: 1,
        pageCount: 1
      },
      search: '',
      workRequestParams: {},
      userWorkRequestParams: {},
      worksLoader: {
        load: false,
        title: 'Пусто',
        description: 'Нет работ, соответствующих заданным параметрам отбора'
      }
    };
  },

  watch: {
    search() {
      this.changePage(1);
    },

    $route() {
      this.$route.name === 'compilation' && this.init();
    }

  },
  methods: {
    init() {
      this.workRequestParams = {
        fields: ['id', 'name', 'thumbWithPath', 'status_id', 'characteristics', 'author.id', 'author.name'].join(','),
        'per-page': 20,
        page: this.PaginationMeta.currentPage,
        expand: ['author', 'compilations'].join(',')
      };
      this.userWorkRequestParams = {
        'per-page': 1000000,
        expand: ['compilation'].join(',')
      };

      if (isNaN(this.$route.params.id)) {
        this.workRequestParams['filter[compilationAccessLink]'] = this.$route.params.id;
        this.userWorkRequestParams['filter[compilationAccessLink]'] = this.$route.params.id;
      } else {
        this.workRequestParams['filter[compilationId]'] = this.$route.params.id;
        this.userWorkRequestParams['filter[compilationId]'] = this.$route.params.id;
      }

      this.requestWorks();
      CompilationsApi.get({
        fields: ['id', 'name']
      }, this.$route.params.id).then(response => this.Compilation = response);
    },

    requestWorks() {
      this.workRequestParams['filter[or][][name][like]'] = this.search;
      this.workRequestParams['filter[or][][authorName][like]'] = this.search;
      this.userWorkRequestParams['filter[or][][name][like]'] = this.search;
      this.userWorkRequestParams['filter[or][][author][like]'] = this.search;
      WorksApi.get(this.workRequestParams).then(response => {
        this.works = response.items;
        this.works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
      });
      if (this.PaginationMeta.currentPage === 1) UserWorksApi.get(this.userWorkRequestParams).then(response => {
        this.userWorks = response.items;
      });
    },

    filterWorks(authorIds = [], years = []) {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      this.worksLoader.load = false;
      this.workRequestParams['filter[year][in]'] = years;
      this.workRequestParams['filter[authorId][in]'] = authorIds;

      if (years.length || authorIds.length) {
        this.userWorks = [];
      } else {
        UserWorksApi.get(this.userWorkRequestParams).then(response => {
          this.userWorks = response.items;
        });
      }

      WorksApi.get(this.workRequestParams).then(response => {
        this.works = response.items;
        this.Works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
        this.worksLoader.load = true;
        loader.close();
      });
    },

    changePage(number) {
      if (number < 1 || this.PaginationMeta.pageCount && number > this.PaginationMeta.pageCount) return;
      this.PaginationMeta.currentPage = number;
      this.workRequestParams.page = number;
      this.requestWorks();
      window.scrollTo(0, 0);
    }

  },

  created() {
    setMetas('compilation');
    this.init();
  }

};